import BaseCWTrainer from './BaseCWTrainer';
import { NUMBERS, LETTERS, SYMBOLS, DISPLAY_MODES } from './constants';
import { CwTrainer } from './cwTrainer';


export default class TeachMeCWTrainer extends BaseCWTrainer {


    // eslint-disable-next-line no-useless-constructor
    constructor(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, displayMode, onDisplay) {
        super(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, displayMode, onDisplay);
    }

    _getTextToSend() {

        let text = '';

        if (this.useLetters) {

            for (let i = 0; i < LETTERS.length; i++) {

                for(let j = 0; j < this.totalCharRepeats; j++) {
                    text += LETTERS[i] + ' ';
                }
            }

            text += '   ';
        }

        if (this.useNumbers) {

            for (let i = 0; i < NUMBERS.length; i++) {

                for(let j = 0; j < this.totalCharRepeats; j++) {
                    text += NUMBERS[i]+ ' ';
                }
            }

            text += '   ';
        }

        if (this.useSymbols) {

            for (let i = 0; i < SYMBOLS.length; i++) {

                for(let j = 0; j < this.totalCharRepeats; j++) {
                    text += SYMBOLS[i]+ ' ';
                }
            }

            text += '   ';
        }

        return text;

    }

    setDisplayMode(displayMode) {

        this.resetCwTrainerCallbacks();            

        switch (displayMode) {
            case DISPLAY_MODES.IMMEDIATE.id: {
                CwTrainer.getInstance().setBeforeCharCallback((character) => {this.onDisplay(character)});
                CwTrainer.getInstance().setAfterCharCallback((character) => {this.onDisplay('')});                                
                break;
            }
            case DISPLAY_MODES.LINGERING.id: {
                CwTrainer.getInstance().setBeforeCharCallback((character) => {this.onDisplay(character)});
                break;
            }
            case DISPLAY_MODES.DELAYED.id: {
                CwTrainer.getInstance().setBeforeCharCallback((character) => {this.onDisplay('')});
                CwTrainer.getInstance().setAfterCharCallback((character) => {this.onDisplay(character)});
                break;
            }
            default: {
                break;
            }
        }
    }

};